import React, { useEffect, useRef, useState } from 'react';
import VForm from 'react-validation/build/form';
import VButton from 'react-validation/build/button';
import VInput from 'react-validation/build/input';
import validator from 'validator';
import { CONSTANTS } from '../../constants';

function Alert({ children }) {
  return (
    <div className="alert alert-danger" role="alert">
      {children}
    </div>
  );
}

function Info(props) {
  const { onSubmit, isLoading, error } = props;
  const [nationalID, setNationalID] = useState('');
  const formRef = useRef();
  const inputRef = useRef();

  useEffect(
    () => {
      if (error) {
        formRef.current.showError(inputRef.current, <Alert>{error}</Alert>);
      } else {
        formRef.current.hideError(inputRef.current);
      }
    },
    [error]
  );

  const requiredV = (value, props) => {
    if (validator.isEmpty(value)) {
      return (
        // We can return string or jsx as the 'error' prop for the validated Component
        <Alert>{CONSTANTS.INFO.NATIONAL_ID_REQUIRED}</Alert>
      );
    }
  };

  const nationalIDV = (value, props) => {
    const isValidNationalID = /^\d{14}$/.test(value.trim());
    if (!isValidNationalID) {
      return (
        // We can return string or jsx as the 'error' prop for the validated Component
        <Alert>{CONSTANTS.INFO.NATIONAL_ID_VALIDATION}</Alert>
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(nationalID);
  };

  return (
    <VForm ref={formRef} onSubmit={handleSubmit} className="halan_form">
      <div className="halan_form_content">
        <label className="halan_input_label">{CONSTANTS.INFO.TITLE}</label>
        <div className="halan_custom_input_content">
          <VInput
            ref={inputRef}
            type="text"
            name="national_id"
            id="national_id"
            maxLength="14"
            value={nationalID}
            onChange={(e) => setNationalID(e.target.value)}
            validations={[requiredV, nationalIDV]}
            placeholder="ex: 1234 1234 1234 12"
            autoComplete="off"
          />
        </div>
      </div>
      <VButton
        className={`halan_btn halan_btn_main ${
          isLoading ? 'halan_btn_loading' : ''
        }`}
      >
        {!isLoading && CONSTANTS.INFO.BTN}
        {isLoading && <div className="halan_loader" />}
      </VButton>
    </VForm>
  );
}

export default Info;
